import { apiRequest } from '../utils/apiClient';

// Phase 8: the professional-service workflows (appraisal / consulting / analysis /
// property-mgmt / facilities) via the generalized ServiceEngagement. Backend
// /api/service-engagements/* — gated by SERVICE_WORKFLOWS_ENABLED.

export type ServiceEngagementType =
  | 'APPRAISAL' | 'CONSULTING' | 'ANALYSIS' | 'PROPERTY_MANAGEMENT' | 'FACILITIES_MANAGEMENT';

export type ServiceEngagementStatus =
  | 'REQUESTED' | 'QUOTED' | 'ACCEPTED' | 'IN_PROGRESS' | 'DELIVERED' | 'COMPLETED' | 'CANCELLED';

export interface ServiceEngagement {
  id: string;
  type: ServiceEngagementType;
  providerActivityId: string;
  clientUserId: string;
  propertyId?: string | null;
  projectId?: string | null;
  title: string;
  description?: string | null;
  status: ServiceEngagementStatus;
  feeAmount?: number | null;
  currency: string;
  scheduledAt?: string | null;
  deliverableUrl?: string | null;
  reportNotes?: string | null;
  createdAt: string;
}

export interface CreateEngagementInput {
  type: ServiceEngagementType;
  providerActivityId: string;
  propertyId?: string;
  projectId?: string;
  title: string;
  description?: string;
  feeAmount?: number;
}

export interface UpdateEngagementInput {
  status?: ServiceEngagementStatus;
  feeAmount?: number;
  scheduledAt?: string;
  deliverableUrl?: string;
  reportNotes?: string;
}

export const ENGAGEMENT_TYPES: ServiceEngagementType[] = [
  'APPRAISAL', 'CONSULTING', 'ANALYSIS', 'PROPERTY_MANAGEMENT', 'FACILITIES_MANAGEMENT',
];

export async function createEngagement(token: string, input: CreateEngagementInput): Promise<ServiceEngagement> {
  const res = await apiRequest<{ data: ServiceEngagement }>('/service-engagements', { method: 'POST', token, body: input });
  return res.data;
}

export async function listMyEngagements(token: string): Promise<ServiceEngagement[]> {
  const res = await apiRequest<{ data: ServiceEngagement[] }>('/service-engagements/mine', { token });
  return res.data ?? [];
}

export async function listIncomingEngagements(token: string): Promise<ServiceEngagement[]> {
  const res = await apiRequest<{ data: ServiceEngagement[] }>('/service-engagements/incoming', { token });
  return res.data ?? [];
}

export async function updateEngagement(token: string, id: string, patch: UpdateEngagementInput): Promise<ServiceEngagement> {
  const res = await apiRequest<{ data: ServiceEngagement }>(`/service-engagements/${id}`, { method: 'PATCH', token, body: patch });
  return res.data;
}
